import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/presentation/components/views/Stake/StakeContainer.tsx");
